import { createRouter, createWebHistory, RouteRecordRaw, createWebHashHistory } from 'vue-router'

const routes: Array<RouteRecordRaw> = [
  // {
  //   path: '/generate/:name?',
  //   name: 'CardGenerator',
  //   props: true,
  //   component: () => import('../views/CardGenerator.vue')
  // },
  {
    path: '/contact/:name',
    name: 'ClientCardPage',
    props: true,
    component: () => import('../views/ClientCardPage.vue'),
  },
  // {
  //   path: '/admin/list',
  //   name: 'CardListPage',
  //   component: () => import('../views/CardListPage.vue'),
  //   props: true
  // },
  // {
  //   path: '/login',
  //   name: 'Login',
  //   component: () => import('../views/LoginPage.vue')
  // },
]

const router = createRouter({
  history: createWebHistory(),
  // history: createWebHashHistory(),
  routes
})

export default router
